"use client";

import { useEffect } from "react";
import { setBetaExperienceCookie } from "../actions";

export const SetBetaExperienceCookie = () => {
    useEffect(() => {
        setBetaExperienceCookie();
    }, []);
    return null;
};
